module.exports = __webpack_public_path__ + "img/sold.60062591.svg";